import { render, staticRenderFns } from "./PressCard.vue?vue&type=template&id=70d42982&scoped=true"
import script from "./PressCard.vue?vue&type=script&lang=js"
export * from "./PressCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d42982",
  null
  
)

export default component.exports